import * as React from "react";

function SvgIcons8ErrorRoundedFilled(props, ref) {
  return (
    <svg viewBox="0 0 26 26" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M25.29 20.133L15.233 2.719c-1.23-2.13-3.238-2.13-4.468 0L.71 20.133C-.52 22.262.488 24 2.945 24h20.11c2.457 0 3.46-1.738 2.234-3.867zM11.616 7.66c.363-.39.82-.586 1.383-.586.563 0 1.02.192 1.383.578.355.383.539.868.539 1.45 0 .496-.75 4.168-1 6.835h-1.809c-.218-2.667-1.035-6.34-1.035-6.835 0-.575.184-1.055.54-1.442zm2.738 12.695A1.886 1.886 0 0113 20.91c-.523 0-.977-.187-1.355-.555a1.806 1.806 0 01-.567-1.343c0-.524.188-.977.567-1.356A1.85 1.85 0 0113 17.09c.523 0 .977.187 1.355.566.38.38.567.832.567 1.356 0 .527-.188.972-.567 1.343z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8ErrorRoundedFilled);
